import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DropdownFilterService } from 'src/app/services/index-service';

@Component({
	selector: 'app-sd-filter',
	template: `
		<app-select-filter 
			[hasIcon] = "hasIcon"
			bindLabel = "name"
			bindValue = "id"
			placeholder = "Select SD"
			label = "SD"
			[clearable]="multiple"
			[multiple] = "multiple"
			[items] = "metadata.data"
			[(value)] = value
			(valueChange)="valueChange.emit(value)"
		>
		</app-select-filter>
    `,
})

export class AppSDFilterComponent implements OnInit {
	@Input() params: Object = {};
	@Input() multiple = false;
	@Input() value: any = null;
	@Output() valueChange = new EventEmitter();
	@Input() hasIcon = false;
	metadata = {
		data: [],
		limit: 100,
		total: 0,
		search: '',
	}
	constructor( private dropdownFilter: DropdownFilterService ) { }

	ngOnInit() {
		this.getSDs();
	}

	getSDs() {
		let mtd = this.metadata;
		if (!mtd.data.length || mtd.data.length < mtd.total) {
			const params = {
				status: 'active',
				limit: mtd.limit,
				offset: mtd.data.length,
				...this.params,
			};
			this.dropdownFilter
				.getSDList(params)
				.subscribe((res: any) => {
					const mappedData = (res.data || []).map(d => {
						return {
							id: d.id,
							name: d.fullName,
						}
					})
					mtd.data = [...mtd.data, ...mappedData];
					mtd.total = res.metadata.total;

					if (mtd.data.length && mtd.data.length < mtd.total) this.getSDs();
					else {
						if (!this.multiple) {
							mtd.data.unshift({
								id: '',
								name: 'All',
							});
							this.value = this.value || mtd.data[0].id;
						}
					}
				});
		}

	}

	filter() {
		this.value = null;
		this.metadata.data = [];
		this.getSDs();
	}
}